/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  invitationId: ZodTypes.Id,
});

export const UserInvitationPost = {
  id: 'user.invitation.post',
  tag: 'User',
  summary: 'Send an invitation to user',
  description: 'Send an invitation to user',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/user/invitation/${params.invitationId}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            accept: z.boolean(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
